__turbopack_context__.v({
  "hideWhenCompact": "styles-module__HEldXG__hideWhenCompact",
  "interactiveRow": "styles-module__HEldXG__interactiveRow",
  "root": "styles-module__HEldXG__root",
  "selectedRow": "styles-module__HEldXG__selectedRow",
  "table": "styles-module__HEldXG__table",
});
